module.exports = __webpack_public_path__ + "static/img/sudu.8d431ec.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/sudu.jpeg
// module id = ejTP
// module chunks = 0